import Flickity from 'flickity/dist/flickity.pkgd.min';
export default {
  init() {
    window.addEventListener('load', () => {
      let slider = new Flickity('.js-slider');
      slider;

      window.addEventListener('resize', () => {
        slider.resize();
      })
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js